import { React, useEffect, useState } from 'react';
import axios from "axios";
import { GlobalLoading, showLoading } from 'react-global-loading';
import { API_URL, getAuthHeaders, getUserClaimsForUi } from '../../../Constant';
import { changeDateFormat, validateRolesIIPManufacturing, formatIipValueByYear, findIipPrevReportByIndustryCode } from "../../../Custom/Custom";
import titlesData from '../../../titles.json';
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import messages from '../../../assets/Messages.json';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { generatePDF } from '../../../Custom/ExportPdf';
import iipTitleData from '../../../iip.json';
import othersData from '../../../others.json';

const MONTH_ORDER = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

const getPreviousMonthYear = (year, month) => {
  const y = parseInt(year, 10);
  const monthIdx = MONTH_ORDER.indexOf(String(month || '').toUpperCase());
  if (monthIdx <= 0) {
    return { year: y - 1, month: 'DEC' };
  }
  return { year: y, month: MONTH_ORDER[monthIdx - 1] };
};

const formatReportDecimal = (rawValue) => {
  const num = parseFloat(rawValue);
  if (rawValue === null || rawValue === undefined || rawValue === '' || Number.isNaN(num)) {
    return '0.00';
  }
  return num.toFixed(2);
};

/** Extract code from "(01)" or "Division(01)" or "01-Division" */
const extractDivisionCodeFromDisplay = (value) => {
  const text = String(value ?? '').trim();
  if (!text) return '';
  const parenMatch = text.match(/\(([^)]*)\)\s*$/);
  if (parenMatch) return String(parenMatch[1] ?? '').trim();
  if (text.includes('-')) return text.split('-')[0].trim();
  return text;
};

/** Always show "Saharanpur Division(01)" using master division list */
const formatDivisionCodeDisplay = (value, divisionList = []) => {
  const code = extractDivisionCodeFromDisplay(value);
  if (!code) return String(value ?? '').trim();

  const match = (Array.isArray(divisionList) ? divisionList : []).find(
    (d) => String(d.DIVISION_CODE ?? '').trim() === String(code).trim()
  );
  if (match?.DIVISION_NAME) {
    return `${match.DIVISION_NAME}(${code})`;
  }

  const text = String(value ?? '').trim();
  // Already has name before parentheses
  if (text.includes('(') && !/^\(.*\)$/.test(text)) {
    return text;
  }
  return `(${code})`;
};

const filterListingRowsByDivisionCode = (rows, selectedDivisionCode) => {
  if (!selectedDivisionCode || selectedDivisionCode === '00') {
    return Array.isArray(rows) ? rows : [];
  }
  const selected = String(selectedDivisionCode).trim();
  return (Array.isArray(rows) ? rows : []).filter((item) => {
    const rowCode = extractDivisionCodeFromDisplay(item?.divisionCode);
    return rowCode === selected;
  });
};

const GetListingReportHQ = () => {
  const shouldHighlightSaveForNextMonth = (item = {}) => {
    const rawValue =
      item?.saveForNextMonth ??
      item?.saveForNextmonth ??
      item?.save_for_next_month ??
      item?.savefornextmonth;

    if (rawValue === true) return true;
    const normalized = String(rawValue ?? '').trim().toLowerCase();
    return normalized === '1' || normalized === 'true';
  };

  const currentDate = new Date();
 
  const currentYear = currentDate.getFullYear();
  const prevMonthDate = new Date(currentDate);
  prevMonthDate.setMonth(currentDate.getMonth() - 1);
  const prevMonthName = prevMonthDate.toLocaleString('default', { month: 'short' }).toUpperCase();
  // Calculate year for previous month - if previous month is in previous year, use previous year
  const prevMonthYear = prevMonthDate.getFullYear();
  const [surveyYear, setSurveyYear] = useState([]);
  const [division, setdivision] = useState([]);
  const [district, setdistrict] = useState([]);
  const [monthName, setMonthName] = useState(prevMonthName);
  const [divisionList, setDivisionList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [selectedDivision, setSelectedDivision] = useState('');
  const [totalNoofNewPendingDSLReport, settotalNoofNewPendingDSLReport] = useState([]);
  const [previousMonthData, setPreviousMonthData] = useState([]);
  const [previousYearData, setPreviousYearData] = useState([]);
  const [previousMonthYear, setPreviousMonthYearApi] = useState('');
  const [previousYearYear, setPreviousYearYearApi] = useState('');
  const [surveyYearRang, setYearNameNext] = useState([]);
  const [yearNameNextTitle, setYearNameNextTitle] = useState(prevMonthYear.toString());
  const [districtName, setdistrictName] = useState([]);
  const [divisionName, setdivisionName] = useState([]);
  const [yearName, setYearName] = useState(prevMonthYear.toString());

  const navigate = useNavigate();

  const decoded = getUserClaimsForUi();
  const userlevelLogin = decoded?.id?.USER_LEVEL_LOCATION;

  const config = getAuthHeaders();

  const userLevel = decoded?.id?.USER_TYPE;
  const districtNameset = decoded?.id?.USER_NAME;
  const storedLanguage = localStorage.getItem('language');

  useEffect(() => {
    const userRole = async () => {
      showLoading(true);
      try {
        const role = await validateRolesIIPManufacturing(decoded);
        if (!role) {
          alert("You are not an authorized for IIP Report");
          navigate("/dashboard");
        }
      } catch (error) {
        console.log(error);
        showLoading(false);
      }
    };

    userRole();

    const fetchDivisionList = async () => {
      try {
        const response = await axios.get(`${API_URL}api/getalldivisionallist`, config);
        const allDivision = response.data;

        if (allDivision.status) {
          setDivisionList(allDivision.data);
          showLoading(false);
        }
      } catch (error) {
        console.error(error);
        showLoading(false);
      }
    };
    fetchDivisionList();
    if (userLevel === "DISTRICT LEVEL") {
      setdistrict(userlevelLogin);
      setdistrictName(districtNameset);
    }
    if (userLevel === "DIVISION LEVEL") {
      handleDivisionChange({ target: { value: userlevelLogin } }, false);
    }
    if (userLevel === "HEAD QUARTER") {
      getallDistrictList();
    }
    handleSubmit(); 

  }, []);

  const getallDistrictList = async () => {
    try {
      const response = await axios.get(`${API_URL}api/getallDistrictList`, config);
      const allDistrictsHQ = response.data;
      setDistrictList(allDistrictsHQ.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = async (event, overrideMonth = null, overrideYear = null, overrideDivision = null, overrideDistrict = null) => {
    if (event) event.preventDefault();

    const monthToUse = overrideMonth !== null ? overrideMonth : monthName;
    const yearToUse = overrideYear !== null ? overrideYear : yearName;

    if (!yearToUse) {
      toast.error('Please Select Survey Year', messages.COLOR_RED);
      return;
    }

    let modifiedDivision = overrideDivision !== null ? overrideDivision : division;
    let modifiedDistrict = overrideDistrict !== null ? overrideDistrict : district;

    if (Array.isArray(modifiedDivision) && modifiedDivision.length === 0) {
      modifiedDivision = "";
    }
    if (Array.isArray(modifiedDistrict) && modifiedDistrict.length === 0) {
      modifiedDistrict = "";
    }

    if (modifiedDivision === "00" || modifiedDistrict === "00") {
      toast.info('Data not found.', messages.COLOR_RED);
      // settotalNoofNewPendingDSLReport([]);
      return false;
    }

    const post_data = {
      "yearProduction": yearToUse,
      "divisionCode": "",
      "districtCode": modifiedDistrict || "",
      "monthProduction": monthToUse
    };



    try {
      showLoading(true);

      const response = await axios.post(`${API_URL}api/iipReports/listReport`, post_data, config);
      const responseData = response.data;
      const pendencyData = responseData.data?.llIIPReportsData || [];
      const prevMonthData = responseData.data?.previousMonthData?.llIIPReportsData || [];
      const prevYearData = responseData.data?.previousYearData?.llIIPReportsData || [];
      const apiPrevMonthYear = responseData.data?.previousMonthData?.year;
      const apiPrevYearYear = responseData.data?.previousYearData?.year;
      showLoading(false);

      const filteredPendencyData = filterListingRowsByDivisionCode(pendencyData, modifiedDivision);

      setPreviousMonthData(prevMonthData || []);
      setPreviousYearData(prevYearData || []);
      setPreviousMonthYearApi(apiPrevMonthYear != null ? String(apiPrevMonthYear) : '');
      setPreviousYearYearApi(apiPrevYearYear != null ? String(apiPrevYearYear) : '');

      if (filteredPendencyData && filteredPendencyData.length > 0) {
        settotalNoofNewPendingDSLReport(filteredPendencyData);
        setPreviousMonthData(prevMonthData);
        setPreviousYearData(prevYearData);
      } else {
        // Show toast message if data is empty
        settotalNoofNewPendingDSLReport([]);
        setPreviousMonthData([]);
        setPreviousYearData([]);
        setPreviousMonthYearApi('');
        setPreviousYearYearApi('');
        toast.error('No data found for this month year', messages.COLOR_RED);
      }

    } catch (error) {
      console.error(error);
      showLoading(false);
      settotalNoofNewPendingDSLReport([]);
      toast.error('Error fetching data', messages.COLOR_RED);
    }
  };

  const handleYearChange = (event) => {
    const selectedYearValue = event.target.value;
    setYearName(selectedYearValue);
    const selectedYear = parseInt(selectedYearValue);
    if (!isNaN(selectedYear)) {
      const nextYear = selectedYear + 1;
      setYearNameNext(`${selectedYear}`);
      setYearNameNextTitle(`${selectedYear}`);
    }
    // Automatically call API when year changes with updated year value
    if (selectedYearValue && monthName) {
      setTimeout(() => {
        handleSubmit(null, monthName, selectedYearValue);
      }, 100);
    }
  };

  const handleDistrictChange = (event) => {
    const selectedDistrict = event.target.value;
    setdistrict(selectedDistrict);
    const _selectedTextDis = event.target.options[event.target.selectedIndex].text;
    const _districtName = _selectedTextDis === "ALL" ? "" : _selectedTextDis;
    setdistrictName(_districtName);
    // Automatically call listReport when district changes
    if (yearName && monthName) {
      setTimeout(() => {
        handleSubmit(null, monthName, yearName, division, selectedDistrict);
      }, 100);
    }
  };

  const handleDivisionChange = async (event, shouldFetchReport = true) => {
    const selectedDivision = event.target.value;
    setdivision(selectedDivision);
    setdistrict([]);
    setdistrictName('');
    if (selectedDivision) {
        // If division is selected, call the district list API immediately
        showLoading(true);
        const post_data = {
            division_Id: selectedDivision
        };
        try {
            const response = await axios.post(`${API_URL}api/geDistrictListByDivisionId`, post_data, config);
            const allDistricts = response.data;
            if (allDistricts.status) {
                setDistrictList(allDistricts.data);
                showLoading(false);
            }
        } catch (error) {
            console.error(error);
            showLoading(false);
        }
    } else {
        setDistrictList([]);
    }
    // Automatically call listReport when division changes (district resets to ALL)
    if (shouldFetchReport && yearName && monthName) {
      setTimeout(() => {
        handleSubmit(null, monthName, yearName, selectedDivision, "");
      }, 100);
    }
};

  const handleMonthChange = (event) => {
    const selectedMonth = event.target.value;
    const now = new Date();
    const currentMonthIndex = now.getMonth();
    const currentYearForMonth = now.getFullYear();
    const selectedMonthIndex = months.findIndex(month => month.value === selectedMonth);
    const selectedYear = parseInt(yearName) || currentYearForMonth;
    
    // Validation: Only check month limit if selected year is current year
    // If selected year is previous year, all months are valid

    if (selectedYear === currentYearForMonth) {

      // For current year, only allow months up to current month

      if (selectedMonthIndex > currentMonthIndex) {
        toast.error('Please select a valid month.', messages.COLOR_RED);
        setMonthName(prevMonthName); // Reset month to previous month
        return;
      }
    }
    // If selected year is previous year, all months are valid (no validation needed)
    
    setMonthName(selectedMonth);

    // Automatically call API when month changes with updated month value

    if (selectedMonth && yearName) {

      // Pass updated month directly to handleSubmit to avoid state update delay

      setTimeout(() => {
        handleSubmit(null, selectedMonth, yearName);
      }, 100);
    }
  };

  const currentDateTimeShow = new Date().toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "long",
    year: "numeric"
  });

  let excelFileName = 'ListReport';

  if (typeof divisionName === 'string' && divisionName !== '') {
    excelFileName = `${excelFileName}_${divisionName.replace(' ', '_')}`;
  }
  if (typeof districtName === 'string' && districtName !== '') {
    excelFileName = `${excelFileName}_${districtName.replace(' ', '_')}`;
  }
  if (typeof monthName === 'string' && monthName !== '') {
    excelFileName = `${excelFileName}_${monthName.replace(' ', '_')}`;
  }
  if (typeof yearName === 'string' && yearName !== '') {
    excelFileName = `${excelFileName}_${yearName.replace(' ', '_')}`;
  }

  const handleGenerateExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(excelFileName.slice(0, 31) || 'ListReport');
    const totalColumns = 18;
    const headerEnglishColumns = [
      'Division Code', 'District Code', 'Industry Code', 'NIC5Digit', 'item', 'Item Name', 'Total Man Days Of Workers', 'Total Manufacturing', 'Units', 'Quantity', 'Value',
      'Previous Year Quantity', 'Previous Year Value', 'Previous Year Variation (%)',
      'Previous Month Quantity', 'Previous Month Value', 'Previous Month Variation (%)',
      'Industry Status'
    ];

    const addMergedTitleRow = (rowNumber, text) => {
      worksheet.mergeCells(rowNumber, 1, rowNumber, totalColumns);
      const cell = worksheet.getCell(rowNumber, 1);
      cell.value = text;
      cell.font = { bold: true, size: 12 };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
    };

    addMergedTitleRow(1, 'Index of Industrial Production, Uttar Pradesh');
    addMergedTitleRow(2, 'Monthly Production Details');
    addMergedTitleRow(3, '(Manufacturing Sector - List Report)');
    addMergedTitleRow(4, `${monthName}-${yearNameNextTitle || yearName}`);
    addMergedTitleRow(5, `Export Date: ${changeDateFormat(new Date())}`);

    const headerRow = worksheet.addRow(headerEnglishColumns);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFE6E6E6' },
      };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    totalNoofNewPendingDSLReport.forEach((item, index) => {
      const prevYearItem = findIipPrevReportByIndustryCode(previousYearData, item);
      const prevMonthItem = findIipPrevReportByIndustryCode(previousMonthData, item);
      const prevMonthPeriod = getPreviousMonthYear(yearName, monthName);

      const currentQty = parseFloat(item.Quantity) || 0;
      const currentVal = parseFloat(item.Value) || 0;
      const prevYearQty = parseFloat(prevYearItem.Quantity) || 0;
      const prevYearVal = parseFloat(prevYearItem.Value) || 0;
      const prevMonthQty = parseFloat(prevMonthItem.Quantity) || 0;
      const prevMonthVal = parseFloat(prevMonthItem.Value) || 0;
      
      // Calculate Previous Year Variation (Quantity)

      const prevYearQtyVariation = prevYearQty !== 0 
        ? ((currentQty - prevYearQty) / prevYearQty) * 100 
        : (currentQty !== 0 ? 100 : 0);
      
      // Calculate Previous Month Variation (Quantity)

      const prevMonthQtyVariation = prevMonthQty !== 0
        ? ((currentQty - prevMonthQty) / prevMonthQty) * 100
        : (currentQty !== 0 ? 100 : 0);

      const rowValues = [
        formatDivisionCodeDisplay(item.divisionCode, divisionList),
        `${item.districtCode}`,
        item.industryCode,
        item.nIC5Digit,
        item.item,
        item.itemName,
        formatReportDecimal(item.totalManDaysOfWorkers),
        formatReportDecimal(item.totalManufacturingDays),
        item.Units,
        item.Quantity === 0 ? '0' : item.Quantity,
        formatIipValueByYear(item.Value, yearName, true),
        prevYearQty === 0 ? '0' : prevYearQty,
        formatIipValueByYear(
          prevYearItem.Value,
          previousYearYear || parseInt(yearName, 10) - 1,
          true
        ),
        prevYearQtyVariation.toFixed(2) + '%',
        prevMonthQty === 0 ? '0' : prevMonthQty,
        formatIipValueByYear(
          prevMonthItem.Value,
          previousMonthYear || prevMonthPeriod.year,
          true
        ),
        prevMonthQtyVariation.toFixed(2) + '%',
        item.industryStatus === '1' ? 'Open' : 'Close'
      ];
      const dataRow = worksheet.addRow(rowValues);
      const shouldHighlight = shouldHighlightSaveForNextMonth(item);

      dataRow.eachCell((cell) => {
        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
        if (shouldHighlight) {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFFFF00' },
          };
        }
      });
    });

    worksheet.columns = [

      { width: 14 }, { width: 18 }, { width: 14 }, { width: 12 }, { width: 10 }, { width: 28 },
      { width: 18 }, { width: 18 }, { width: 12 }, { width: 14 }, { width: 16 }, { width: 18 },
      { width: 18 }, { width: 18 }, { width: 18 }, { width: 18 }, { width: 18 }, { width: 14 },

    ];

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), `${excelFileName}.xlsx`);
  };

  const handleGeneratePdf = () => {
    const heading1 = "Index of Industrial Production, Uttar Pradesh";
    const heading2 = "Monthly Production Details";
    const heading3 = "(Manufacturing Sector - List Report)";
    const heading4 = `${monthName}-${yearNameNextTitle || yearName}`;

    const headerEnglishColumns = [
        'Division Name', 'District Name', 'Industry Code', 'NIC5Digit', 'item', 'Item Name',
        'Total Man Days Of Workers', 'Total Manufacturing', 'Units', 'Quantity', 'Value',
        'Previous Year Quantity', 'Previous Year Value', 'Previous Year Variation (%)',
        'Previous Month Quantity', 'Previous Month Value', 'Previous Month Variation (%)',
        'Industry Status'
    ];

    const highlightedRowIndexes = [];
    const pdfData = totalNoofNewPendingDSLReport.map((item, index) => {
      const prevYearItem = findIipPrevReportByIndustryCode(previousYearData, item);
      const prevMonthItem = findIipPrevReportByIndustryCode(previousMonthData, item);
      const prevMonthPeriod = getPreviousMonthYear(yearName, monthName);
      if (Number(item.saveForNextMonth) === 1) {
        highlightedRowIndexes.push(index);
      }
      
      const currentQty = parseFloat(item.Quantity) || 0;
      const currentVal = parseFloat(item.Value) || 0;
      const prevYearQty = parseFloat(prevYearItem.Quantity) || 0;
      const prevYearVal = parseFloat(prevYearItem.Value) || 0;
      const prevMonthQty = parseFloat(prevMonthItem.Quantity) || 0;
      const prevMonthVal = parseFloat(prevMonthItem.Value) || 0;
      
      // Calculate Previous Year Variation (Quantity)
      const prevYearQtyVariation = prevYearQty !== 0 
        ? ((currentQty - prevYearQty) / prevYearQty) * 100 
        : (currentQty !== 0 ? 100 : 0);
      
      // Calculate Previous Month Variation (Quantity)
      const prevMonthQtyVariation = prevMonthQty !== 0 
        ? ((currentQty - prevMonthQty) / prevMonthQty) * 100 
        : (currentQty !== 0 ? 100 : 0);
      
      return [
        formatDivisionCodeDisplay(item.divisionCode, divisionList),
        `${item.districtCode}`,
        item.industryCode,
        item.nIC5Digit,
        item.item,
        item.itemName,
        formatReportDecimal(item.totalManDaysOfWorkers),
        formatReportDecimal(item.totalManufacturingDays),
        item.Units,
        item.Quantity === 0 ? '0' : item.Quantity,
        formatIipValueByYear(item.Value, yearName, true),
        prevYearQty === 0 ? '0' : prevYearQty,
        formatIipValueByYear(
          prevYearItem.Value,
          previousYearYear || parseInt(yearName, 10) - 1,
          true
        ),
        prevYearQtyVariation.toFixed(2) + '%',
        prevMonthQty === 0 ? '0' : prevMonthQty,
        formatIipValueByYear(
          prevMonthItem.Value,
          previousMonthYear || prevMonthPeriod.year,
          true
        ),
        prevMonthQtyVariation.toFixed(2) + '%',
        item.industryStatus === '1' ? 'Open' : 'Close'
      ];
    });

  
    const PDFFileName = excelFileName;

    // Debug: Check if data is properly prepared
    console.log('PDF Data Preparation:', {
        headerEnglishColumnsLength: headerEnglishColumns.length,
        headerEnglishColumns: headerEnglishColumns,
        pdfDataLength: pdfData.length,
        firstRowLength: pdfData[0] ? pdfData[0].length : 0,
        firstRowData: pdfData[0],
        previousYearDataLength: previousYearData.length,
        previousMonthDataLength: previousMonthData.length
    });

    const pdfObjectData = {
        heading1,
        heading2,
        heading3,
        heading4,
        headerEnglishColumns,
        pdfData,
        highlightedRowIndexes,
        width: [52, 60, 70, 70, 70, 70, 100, 60, 60, 52, 90, 100, 80, 100, 100, 90, 90, 90],
        PDFFileName
    };

    generatePDF(pdfObjectData);
};


  const months = [
    { value: 'JAN', label: 'January' },
    { value: 'FEB', label: 'February' },
    { value: 'MAR', label: 'March' },
    { value: 'APR', label: 'April' },
    { value: 'MAY', label: 'May' },
    { value: 'JUN', label: 'June' },
    { value: 'JUL', label: 'July' },
    { value: 'AUG', label: 'August' },
    { value: 'SEP', label: 'September' },
    { value: 'OCT', label: 'October' },
    { value: 'NOV', label: 'November' },
    { value: 'DEC', label: 'December' },
  ];


  return (
    <>
      <ToastContainer />
      <GlobalLoading />
      <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
          <div className="card-body pb-1">
            <div className="row align-items-center">
              <h4 className="page_heading">
              <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? iipTitleData.hi.MANUFACTURING_SECTOR_LIST_REPORT : iipTitleData.en.MANUFACTURING_SECTOR_LIST_REPORT }} />
              </h4>

              {userLevel === "HEAD QUARTER" && (
            <>
            
              <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                 <label>Division</label>
                 <select value={division} onChange={handleDivisionChange} name="division" className="form-select">
                <option value="">ALL</option>
                {divisionList.length > 0 && divisionList.map((ele, index) => (
                  <option key={ele.DIVISION_NAME} value={ele.DIVISION_CODE}>
                    {ele.DIVISION_CODE}{'-'}{ele.DIVISION_NAME}
                  </option>
                  
                ))}
                 </select>
              </div>

              <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                <label>District</label>
                <select value={district} onChange={handleDistrictChange} name="district" className="form-select">
                  <option value="">ALL</option>
                  {districtList.map((ele, index) => (
                    <option key={ele.DISTRICT_CODE} value={ele.DISTRICT_CODE}>
                      {ele.DISTRICT_CODE}{'-'}{ele.DISTRICT_NAME}
                    </option>
                  ))}
                </select>
              </div>

            </>
              )}


              {userLevel === "DIVISION LEVEL" && (
              <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                <label>District</label>
                <select value={district} onChange={handleDistrictChange} name="district" className="form-select">
                  <option value="">ALL</option>
                  {districtList.map((ele, index) => (
                    <option key={ele.DISTRICT_CODE} value={ele.DISTRICT_CODE}>
                      {ele.DISTRICT_CODE}{'-'}{ele.DISTRICT_NAME}
                    </option>
                  ))}
                </select>
              </div>
               )}

              <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                <label>Month</label>
                <select value={monthName} onChange={handleMonthChange} name="month" className="form-select">
                  <option value="" >Select Month</option>
                  {months.map(month => (

                    <option key={month.value} value={month.value}>{month.label}</option>
                  ))}
                </select>
              </div>

              <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                <label>Year</label>
                <select value={yearName} onChange={handleYearChange} name="surveyYear" className="form-select">
                  <option value="">Select Year</option>
                  {Array.from({ length: currentYear - 2020 }, (_, i) => {
                    const year = currentYear - i;
                    return (
                      <option key={year} value={year.toString()}>
                        {year}
                      </option>
                    );
                  })}
                </select>
              </div>



              <div className="col-xl-2 col-lg-12 mb-3">
                <label className="w-100 d-none d-sm-block">&nbsp;</label>
                <button onClick={handleSubmit} type="submit" className="btn btn_orange">Search</button>
              </div>

              <div className="col-xl-2 col-lg-12 mb-3 text-end">
                <label className="w-100 d-none d-sm-block">&nbsp;</label>
                <a href="javascript:void(0);" onClick={handleGenerateExcel} className="btn btn_green px-1 ms-auto"><img src="assets/images/excel.svg" className="me-2" />Excel</a>
                <a href="javascript:void(0);" onClick={handleGeneratePdf} className="btn btn_green ms-1 px-1"><img src="assets/images/pdf.svg" className="me-2" />PDF</a>
              </div>
            </div>
          </div>
        </div>

        <div className="card mx-3 mb-3">
          <div className="card-body p-0">
            <div className="table-responsive" style={{ maxHeight: '80vh', overflowX: 'auto' }}>
              <table className="table table-bordered table-sm mb-0" style={{ minWidth: '100%', fontSize: '0.85rem' }}>
                <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                  <tr>
                    <th style={{ minWidth: '50px', width: '50px' }}>Sr. No</th>
                    <th style={{ minWidth: '80px', width: '80px' }}>Division Code</th>
                    <th style={{ minWidth: '90px', width: '90px' }}>District Code</th>
                    <th style={{ minWidth: '90px', width: '90px' }}>Industry Code</th>
                    <th style={{ minWidth: '90px', width: '90px' }}>NIIC 5 Digit</th>
                    <th style={{ minWidth: '70px', width: '70px' }}>Item</th>
                    <th style={{ minWidth: '200px', width: '200px' }}>Item Name</th>
                    <th style={{ minWidth: '120px', width: '120px' }}>Total Man Days of Workers</th>
                    <th style={{ minWidth: '130px', width: '130px' }}>Total Manufacturing Days</th>
                    <th style={{ minWidth: '60px', width: '60px' }}>Unit</th>
                    <th style={{ minWidth: '90px', width: '90px' }}>Quantity</th>
                    <th style={{ minWidth: '100px', width: '100px' }}>Value</th>
                    <th style={{ minWidth: '120px', width: '120px' }}>Previous Year Quantity</th>
                    <th style={{ minWidth: '120px', width: '120px' }}>Previous Year Value</th>
                    <th style={{ minWidth: '150px', width: '150px' }}>Previous Year Variation (%)</th>
                    <th style={{ minWidth: '120px', width: '120px' }}>Previous Month Quantity</th>
                    <th style={{ minWidth: '120px', width: '120px' }}>Previous Month Value</th>
                    <th style={{ minWidth: '150px', width: '150px' }}>Previous Month Variation (%)</th>
                    <th style={{ minWidth: '100px', width: '100px' }}>Industry Status</th>
                  </tr>
                </thead>

                <tbody>
                  {totalNoofNewPendingDSLReport.length > 0 ? (
                    totalNoofNewPendingDSLReport.map((item, index) => {
                      const prevYearItem = findIipPrevReportByIndustryCode(previousYearData, item);
                      const prevMonthItem = findIipPrevReportByIndustryCode(previousMonthData, item);
                      const prevMonthPeriod = getPreviousMonthYear(yearName, monthName);
                      
                      const currentQty = parseFloat(item.Quantity) || 0;
                      const currentVal = parseFloat(item.Value) || 0;
                      const prevYearQty = parseFloat(prevYearItem.Quantity) || 0;
                      const prevYearVal = parseFloat(prevYearItem.Value) || 0;
                      const prevMonthQty = parseFloat(prevMonthItem.Quantity) || 0;
                      const prevMonthVal = parseFloat(prevMonthItem.Value) || 0;
                      
                      // Calculate Previous Year Variation (Quantity)
                      const prevYearQtyVariation = prevYearQty !== 0 
                        ? ((currentQty - prevYearQty) / prevYearQty) * 100 
                        : (currentQty !== 0 ? 100 : 0);
                      
                      // Calculate Previous Month Variation (Quantity)
                      const prevMonthQtyVariation = prevMonthQty !== 0 
                        ? ((currentQty - prevMonthQty) / prevMonthQty) * 100 
                        : (currentQty !== 0 ? 100 : 0);
                      
                      const shouldHighlight = shouldHighlightSaveForNextMonth(item);
                      const highlightedCellStyle = shouldHighlight
                        ? { backgroundColor: '#fff59d' }
                        : {};

                      return (
                        <tr key={index} style={shouldHighlight ? { backgroundColor: '#fff59d' } : {}}>
                          <td style={{ textAlign: 'center' }}>{index + 1}</td>
                          <td style={{ textAlign: 'center' }}>{formatDivisionCodeDisplay(item.divisionCode, divisionList)}</td>
                          <td style={{ textAlign: 'center' }}>{item.districtCode}</td>
                          <td style={{ textAlign: 'center' }}>{item.industryCode}</td>
                          <td style={{ textAlign: 'center' }}>{item.nIC5Digit}</td>
                          <td style={{ textAlign: 'center' }}>{item.item}</td>
                          <td style={{ wordBreak: 'break-word' }}>{item.itemName}</td>
                          <td style={{ textAlign: 'right' }}>{formatReportDecimal(item.totalManDaysOfWorkers)}</td>
                          <td style={{ textAlign: 'right' }}>{formatReportDecimal(item.totalManufacturingDays)}</td>
                          <td style={{ textAlign: 'center' }}>{item.Units}</td>
                          <td style={{ textAlign: 'right' }}>{item.Quantity === 0 ? '0' : item.Quantity}</td>
                          <td style={{ textAlign: 'right' }}>{formatIipValueByYear(item.Value, yearName, true)}</td>
                          <td style={{ textAlign: 'right' }}>{prevYearQty === 0 ? '0' : prevYearQty}</td>
                          <td style={{ textAlign: 'right' }}>{formatIipValueByYear(prevYearItem.Value, previousYearYear || parseInt(yearName, 10) - 1, true)}</td>
                          <td style={{ textAlign: 'center' }}>
                            {prevYearQtyVariation !== null && prevYearQtyVariation !== undefined ? (
                              <span style={{ 
                                color: prevYearQtyVariation >= 0 ? '#28a745' : '#dc3545',
                                fontWeight: 'bold',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '4px',
                                whiteSpace: 'nowrap'
                              }}>
                                {prevYearQtyVariation >= 0 ? '↑' : '↓'} {Math.abs(prevYearQtyVariation).toFixed(2)}%
                              </span>
                            ) : ''}
                          </td>
                          <td style={{ textAlign: 'right' }}>{prevMonthQty === 0 ? '0' : prevMonthQty}</td>
                          <td style={{ textAlign: 'right' }}>{formatIipValueByYear(prevMonthItem.Value, previousMonthYear || prevMonthPeriod.year, true)}</td>
                          <td style={{ textAlign: 'center' }}>
                            {prevMonthQtyVariation !== null && prevMonthQtyVariation !== undefined ? (
                              <span style={{ 
                                color: prevMonthQtyVariation >= 0 ? '#28a745' : '#dc3545',
                                fontWeight: 'bold',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '4px',
                                whiteSpace: 'nowrap'
                              }}>
                                {prevMonthQtyVariation >= 0 ? '↑' : '↓'} {Math.abs(prevMonthQtyVariation).toFixed(2)}%
                              </span>
                            ) : ''}
                          </td>
                          <td style={{ textAlign: 'center', ...highlightedCellStyle }}>{item.industryStatus === "1" ? 'Open' : 'Close'}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="19" style={{ textAlign: 'center', padding: '20px' }}>
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>
    </>
  );
}

export default GetListingReportHQ;
